/* eslint-disable max-len */
import Modernizr from 'modernizr';

class Home {
  constructor() {
    this.categories = document.getElementsByClassName('js-navigation-category');
  }
  cache() {
    this.$body = $(document.body);
    this.$slideMenuContainer = $('.js-slide-menu-container');
  }
  init() {
    // Build cache
    this.cache();

    const home = this;

    if (window.location.hash) {
      home.filterByCategoryId(window.location.href);
    }

    $('.js-navigation').click((e) => {
      let target = e.target;

      if (!target.classList.contains('js-navigation-category')) {
        if (target.parentNode.classList.contains('js-navigation-category')) {
          target = target.parentNode;
        } else {
          return;
        }
      }

      e.preventDefault();

      home.filterByCategoryId(target.href, home);
    });

    $('.js-sticky-picked').click((e) => {
      e.preventDefault();

      home.filterByCategoryId(e.currentTarget.href, home);
    });
  }
  filterByCategoryId(id, home) {
    // Check if we need to wait for menu to close, so that the Vue app loads
    // more gallery items correctly.
    if (home && Modernizr.mq('(max-width: 1219px)') && home.$slideMenuContainer.is(':visible')) {
      home.$body.trigger('galleryChange');
      setTimeout(() => {
        home.filterByCategoryId(id);
      }, 350); // @ref01 if changing this, change also in ./common.js (notice that this is +50 larger).
      return;
    }

    const catId = this.constructor.verifyCatId(id);
    if (catId) {
      window.filterIsoGallery(catId);
      Array.prototype.forEach.call(this.categories, (el) => {
        if (this.constructor.verifyCatId(el.href) === catId) {
          el.classList.add('is-active');
        } else {
          el.classList.remove('is-active');
        }
      });
    }
  }
  static verifyCatId(id) {
    const catId = +id.substring(id.indexOf('#') + 1);
    return Number.isInteger(catId) ? catId : 0;
  }
}

export default new Home();



// WEBPACK FOOTER //
// ./scripts/routes/home.js